<template>
  <div class="sku-details">
    <div class="breadcrumb" style="background: #fff">{{ $route.query.type === 'check' ? '查看SKU组' : '审核SKU组' }}</div>
    <div class="third-title"><span>SKU组基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="150px">
        <el-form-item label="SKU组名称:">{{ basicInfo.skuGroupName }}</el-form-item>
        <!-- <el-form-item label="SKU组属性:">{{ basicInfo.dictSet }}</el-form-item> -->
        <div v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-form-item :label="item[0] + ':'" v-for="(item) in basicInfo.dictList" :key="item.id">
            <span>{{ item[1] }}</span>
            <!-- <el-select v-model="dictList[index].value" value-key="id" placeholder="请选择">
              <el-option v-for="ele in item.vals" :key="ele.id" :label="ele.propVal" :value="ele"></el-option>
            </el-select> -->
          </el-form-item>
        </div>
        <el-form-item label="SKU组图片:">
          <div id="show_img">
            <img :src="basicInfo.skuGroupImage" alt="">
          </div>
        </el-form-item>
        <el-form-item class="noleft-third-title" v-if="$route.query.spuProperty !== 'NORMAL'">
          <div class="third-title"><span>SKU组详细信息</span></div>
        </el-form-item>
        <el-form-item label="SKU:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <div style="max-width: 1500px;margin-top:10px">
            <el-table :data="basicInfo.skuList" border>
              <el-table-column label="SKUID" prop="id"></el-table-column>
              <el-table-column label="SKU名称" prop="skuName"></el-table-column>
              <el-table-column label="SKU前端显示名称" prop="skuFrontName"></el-table-column>
              <el-table-column label="基础P数" prop="basePage"></el-table-column>
              <el-table-column label="最大P数" prop="maxPage"></el-table-column>
              <el-table-column label="一次增加P数" prop="baseStep"></el-table-column>
              <el-table-column label="基础P平台价格" prop="basePagePrice"></el-table-column>
              <el-table-column label="增加一次平台价格" min-width="100px" prop="baseStepPrice"></el-table-column>
              <el-table-column label="基础P在线支付价格" min-width="100px" prop="onlineSalePrice"></el-table-column>
              <el-table-column label="增加一次在线支付价格" min-width="100px" prop="onlineBaseStepPrice"></el-table-column>
              <!-- 新加的 -->
              <el-table-column prop="startupsBasePagePrice" label="基础P初创平台价格" min-width="130px" v-if="startupsSpu == 'true'"></el-table-column>
              <el-table-column prop="startupsBaseStepPrice" label="增加一次初创平台价价格" min-width="130px" v-if="startupsSpu == 'true'"></el-table-column>
              <el-table-column label="基础P推荐终端价格" min-width="100px" prop="terminalSalePrice"></el-table-column>
              <el-table-column label="增加一次推荐终端价格" min-width="100px" prop="terminalStepSalePrice"></el-table-column>
              <!-- <el-table-column label="最低终端价格" min-width="130px" prop="salePrice"></el-table-column> -->
              <el-table-column label="尺寸">
                <template slot-scope="scope">
                  <span class="color-blue" @click="checkSizeGroup(scope.row)">查看尺寸组</span>
                </template>
              </el-table-column>
              <el-table-column label="模板">
                <template slot-scope="scope">
                  <span class="color-blue" @click="tempAdmin(scope)" v-permission="'pts:admin:group:list'">查看模板</span>
                </template>
              </el-table-column>
              <!-- v-if="isDiy" -->
              <el-table-column label="收选片模板" v-permission="'pts:admin:group:list'">
                <template slot-scope="scope">
                  <span :class="isDiy ? 'color-blue' : ''"
                    @click="$refs.adminPickCollTemplate.show(scope.row.id, scope.row.composeSizeGroupId, defaultSizeGroup.groupName, scope.row.maxPage)">查看收选片模板</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="color-blue " v-permission="'pms:admin:sku:detail'" @click="isEditSku = 'check', editSku(scope.row)">查看<br></span>
                </template>
              </el-table-column>
            </el-table>
            <adminPickCollTemplate ref="adminPickCollTemplate" />
          </div>
        </el-form-item>
        <el-form-item label="详细价格表:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-button round @click="count">计算</el-button>
        </el-form-item>
        <el-form-item label="" v-if="isShow" class="price-details">
          <div style="width: 500px;" v-for="(item, index) in priceTableList" :key="index">
            <el-table :data="item" border style="width: 500px">
              <el-table-column prop="page" label="P数"></el-table-column>
              <el-table-column prop="price" label="余额支付价格"></el-table-column>
              <el-table-column prop="onlinePrice" label="在线支付价格"></el-table-column>
              <el-table-column prop="salePrice" label="推荐终端价格"></el-table-column>
              <el-table-column prop="startupsPrice" label="初创平台价格"></el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="样品价格:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <span style="display:inline-block;width:200px;">{{ basicInfo.samplePrice }}</span>
        </el-form-item>
        <el-form-item label="样品积分价格:" v-if="$route.query.spuProperty !== 'NORMAL' && $route.query.showPoint == 'true'">
          <span style="display:inline-block;width:200px;">{{ basicInfo.samplePoints }}</span>
        </el-form-item>
        <el-form-item label="在线支付样品价格:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <span style="display:inline-block;width:200px;">{{ basicInfo.onlineSamplePrice }}</span>
        </el-form-item>
        <el-form-item label="初创平台样品价格:" v-if="$route.query.spuProperty !== 'NORMAL' && startupsSpu == 'true'">
          <span style="display:inline-block;width:200px;">{{ basicInfo.startupsSamplePrice }}</span>
        </el-form-item>
        <el-form-item label="样品主题:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <div style="width: 402px">
            <el-table :data="basicInfo.sampleThemeList" border>
              <!-- <el-table-column label="样品编码" prop="sampleBarCode"></el-table-column> -->
              <el-table-column label="主题" prop="themeName"></el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL'" label="平台价格:"> {{ basicInfo.skuList[0].basePagePrice }}
          <!-- <el-input v-model="basicInfo.skuList[0].basePagePrice" placeholder=""></el-input> -->
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL' && $route.query.showPoint === 'true'" label="积分价格:"> {{ basicInfo.skuList[0].basePagePoints }}
          <!-- <el-input v-model="basicInfo.skuList[0].basePagePrice" placeholder=""></el-input> -->
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL'" label="在线支付价格:"> {{ basicInfo.skuList[0].onlineSalePrice }}
          <!-- <el-input v-model="basicInfo.skuList[0].onlineSalePrice" placeholder=""></el-input> -->
        </el-form-item>
        <!-- 新加的 -->
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL' && startupsSpu == 'true'" label="初创平台价格:"> {{ basicInfo.skuList[0].startupsBasePagePrice }}
          <!-- <el-input v-model="basicInfo.skuList[0].startupsBasePagePrice" placeholder=""></el-input> -->
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL'" label="推荐终端价格:"> {{ basicInfo.skuList[0].salePrice }}
          <!-- <el-input v-model="basicInfo.skuList[0].salePrice" placeholder=""></el-input> -->
        </el-form-item>
        <el-form-item v-if="$route.query.spuProperty === 'NORMAL'" label="通货编码:"> {{ basicInfo.skuList[0].sampleBarCode }} </el-form-item>
        <el-form-item label="特殊价格:" v-permission="'pms:admin:special:store:list'">
          <div style="width: 500px">
            <el-table :data="specialStoreList" border>
              <el-table-column label="平台号" prop="storeCode"></el-table-column>
              <el-table-column label="平台名称" prop="storeName"></el-table-column>
              <el-table-column label="业务" prop="salesman"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span @click="$router.push({ path: '/pricedetail', query: { id: scope.row.id } })" class="color-blue">查看</span><br>
                  <span @click="deleteSP(scope.row)" class="color-blue">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="库存:"> {{ basicInfo.stockCount }} </el-form-item>
        <el-form-item label="有效期:" v-if="basicInfo.isTimeLimit"> {{ basicInfo.timeLimitStartTime + ' 到 ' + basicInfo.timeLimitEndTime }} </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0" v-if="$route.query.type !== 'audit'">
      <el-button type="primary" @click="$router.go(-1)" round>确定</el-button>
    </div>
    <div class="form-btn" style="margin: 20px 0" v-if="$route.query.type === 'audit'">
      <el-button @click="check('审核拒绝')" round>审核拒绝</el-button>
      <el-button round type="primary" @click="checkDialog = true">审核通过</el-button>
    </div>
    <!-- 审核通过 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="checkDialog" width="30%">
      <h2>审核通过确定</h2>
      <p>是否确定审核通过？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="check('审核通过')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看尺寸组 -->
    <el-dialog :close-on-click-modal="false" width="900px" title="尺寸组" :visible.sync="haddleSizeGroupDialog">
      <el-table :data="checkSizeGroupTableData" border>
        <el-table-column type="expand">
          <template v-slot='scope'>
            <div style="width:100%;height:100%;background:red">
              <el-table :data="scope.row.sizeList" border>
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="页面类型">
                  <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
                </el-table-column>
                <el-table-column label="页面名称" prop="pageName"></el-table-column>
                <el-table-column label="宽高">
                  <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                <el-table-column label="出血" width="220px">
                  <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight
                  }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                </el-table-column>
                <el-table-column label="码" prop="barCodeId">
                  <template slot-scope="scope">
                    <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
        <el-table-column label="尺寸组类" prop="composeSizeGroupCategory.categoryName" min-width="100px"></el-table-column>
        <el-table-column label="页面名称" prop="pageName" min-width="100px"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 管理模板 -->
    <el-dialog :close-on-click-modal="false" width="75%" title="模板" :visible.sync="templateDialog">
      <el-form :inline="true" :model="searchGroupVo" class="demo-form-inline">
        <el-form-item label="模板名称:">
          <el-input v-model="searchGroupVo.groupName" placeholder="请输入模板名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="模板主题:">
          <el-select v-model="searchGroupVo.templateThemeId" placeholder="请选择" clearable>
            <el-option v-for="item in sampleList" :key="item.id" :label="item.themeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板页性质:">
          <el-select v-model="searchGroupVo.propertyId" clearable placeholder="请选择">
            <el-option v-for="item in propertyList" :key="item.id" :label="item.propertyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否关联尺寸组:">
          <el-select v-model="searchGroupVo.isAssociatedeSizeGroup" placeholder="请选择" clearable>
            <el-option label="不关联" value="0"></el-option>
            <el-option label="关联" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期:">
          <el-date-picker clearable v-model="value" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item style="float:right;margin-right:20px">
          <el-button round @click="tempQueryInfo.pageNum = 1, getTemplateThemeList()">查询</el-button>
          <!-- <el-button round v-show="addCorrelation" @click="Correlation()" type="primary">关联</el-button>
          <el-button round v-show="!addCorrelation" @click="cancelCorrelation()" type="primary">取消关联</el-button>
          <el-button round v-show="!addCorrelation"
            @click="searchGroupVo.propertyId = propertyList[0].id,sizeGroupQueryInfo.pageNum=1,searchGroupVo.skuId='',getTemplateThemeList(),addCorrelation=true"
            type="primary">添加关联</el-button> -->
        </el-form-item>
      </el-form>
      <el-table :data="templateGroupList" border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="groupName" label="模板名称"></el-table-column>
        <el-table-column prop="propertyName" label="模板页性质"></el-table-column>
        <el-table-column prop="payDate" label="模板页数量">
          <template slot-scope="scope">
            <!-- <p v-for="item in scope.row.templateList" :key="scope.row.id + item.typeName">
              <span @click="getTemplateGroupMsg(scope.row.id), checkTemplateDialog = true" class="color-blue">{{ item.typeName + '模板：' + item.templateNum }}</span>
            </p> -->
            <p v-for="item in scope.row.templateGroupList" :key="scope.row.id + item.typeName">
              <span @click="getTemplateGroupMsg(scope.row.id), checkTemplateDialog = true" class="color-blue">{{ item.typeName + '模板：' + item.templateGroupNum }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="isAssociatedeSizeGroup" label="是否关联尺寸组">
          <template slot-scope="scope"> {{ scope.row.isAssociatedeSizeGroup === 1 ? '是' : '否' }} </template>
        </el-table-column>
        <el-table-column prop="themeName" label="主题"></el-table-column>
        <el-table-column prop="createdTime" label="创建日期"></el-table-column>
      </el-table>
      <v-pagination class="v-pagination" :queryInfo="tempQueryInfo" @changePage="changePage"></v-pagination>
      <el-dialog :close-on-click-modal="false" width="50%" title="查看模板" :visible.sync="checkTemplateDialog" append-to-body>
        <!-- <img style="width:150px;margin:0 5px 5px 0;border:2px solid #000" v-for="item in templateList" :key="item.id + item.sorting" :src="item.templateThumbnail" alt=""> -->
        <div style="display: flex;flex-direction:row;flex-wrap:wrap;">
          <div v-for="item in templateList" :key="item.id + item.sorting">
            <img style="width:150px;margin:0 5px 5px 0;border:2px solid #000" :src="item.templateThumbnail" alt="">
            <div style="width:150px;text-align: center;margin-bottom: 10px;">{{ item.pageTypeCode ? item.pageTypeCode === 'TEXT' ? '内页' : item.pageTypeCode === 'COVER' ? '封面' : '单页' : '' }}</div>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
    <!-- 查看sku -->
    <el-dialog :close-on-click-modal="false" title="SKU设置" @closed="closed" :visible.sync="addSkuDialog" width="800px">
      <el-form ref="formaaa" v-show="addSkuStep === 1" :model="skuMsg" label-width="160px">
        <el-form-item label="SKU名称：" prop="skuName">
          <el-input v-if="isEditSku !== 'check'" v-model="skuMsg.skuName" placeholder="" style="width:300px;"></el-input>
          <span v-else>{{ skuMsg.skuName }}</span>
        </el-form-item>
        <el-form-item label="SKU前端显示名称：" prop="skuFrontName">
          <el-input v-if="isEditSku !== 'check'" v-model="skuMsg.skuFrontName" placeholder="" style="width:300px;"></el-input>
          <span v-else>{{ skuMsg.skuFrontName }}</span>
        </el-form-item>
        <el-form-item label="尺寸组：">
          <span>{{ skuMsgName }}</span>
          <el-button type="primary" style="margin-left:20px" @click="type = 'sku', getSizeGroupList(), sizeDialog = true" round v-if="isEditSku !== 'check'">选择尺寸组 </el-button>
        </el-form-item>
        <el-form-item label="页面名称：">
          <el-table :data="pageNameTableData" style="width: 500px">
            <el-table-column prop="pageName" label="页面名称"></el-table-column>
            <el-table-column prop="typeName" label="页面类型">
              <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <el-input v-if="scope.row.isEditable" @input="countP" style="width:100px" v-model="scope.row.pageNum" placeholder="" :disabled="isEditSku === 'check'">
                </el-input>
                <span v-if="!scope.row.isEditable">{{ scope.row.pageNum }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="用户应上传照片张数 :" prop="uploadPhotoNum" v-if="skuMsg.spuType == 'photo'">
          <div v-if="isEditSku !== 'check' && !isdisabled">
            <el-input v-model="skuMsg.uploadPhotoNum" placeholder=""></el-input>张
          </div>
          <span v-else>{{ skuMsg.uploadPhotoNum ? skuMsg.uploadPhotoNum : skuMsg.basePage }}张</span>
        </el-form-item>
        <el-form-item label="重量:" prop="weight">
          <div v-if="isEditSku !== 'check' && !isdisabled">
            <el-input v-model="skuMsg.weight" placeholder=""></el-input>g
          </div>
          <span v-else>{{ skuMsg.weight }}g</span>
        </el-form-item>
        <el-form-item label="是否合成半P:">
          <span>{{ skuMsg.isComposeHalfP == false ? '否' : skuMsg.isComposeHalfP == true ? '是' : '' }}</span>
        </el-form-item>
        <el-form-item label="封面合成位置:" prop="coverPosition">
          <el-select v-if="isEditSku !== 'check' && !isdisabled" v-model="skuMsg.coverPosition" value-key="id" placeholder="请选择" clearable>
            <el-option label="首页" value="FIRST_PAGE"></el-option>
            <el-option label="尾页" value="LAST_PAGE"></el-option>
          </el-select>
          <span v-else>{{ skuMsg.coverPosition == 'FIRST_PAGE' ? '首页' : skuMsg.coverPosition == 'LAST_PAGE' ? '尾页' : '' }}</span>
        </el-form-item>
        <el-form-item label="封面合成坐标:" prop="param"> 左：<el-input v-if="isEditSku !== 'check' && !isdisabled" type="number" style="width:200px" v-model="skuMsg.leftParam" placeholder=""><template
              slot="append">mm</template>
          </el-input><span v-else>{{ skuMsg.leftParam }}mm</span> 上：<el-input v-if="isEditSku !== 'check' && !isdisabled" style="width:200px" type="number" v-model="skuMsg.topParam" placeholder="">
            <template slot="append">mm</template>
          </el-input>
          <span v-else>{{ skuMsg.topParam }}mm</span>
        </el-form-item>
        <el-form-item label="是否为0元购产品:">
          <span>{{ skuMsg.isZeroPurchase == false ? '否' : skuMsg.isZeroPurchase == true ? '是' : '' }}</span>
        </el-form-item>
        <el-form-item label="照片张数是否限制:" prop="limitQuantity">
          <span>{{ skuMsg.limitQuantity == false ? '否' : skuMsg.limitQuantity == true ? '是' : '' }}</span>
        </el-form-item>
        <el-form-item label="是否特殊效果:" prop="specialPrint">
          <span>{{ skuMsg.specialPrint == 0 ? '否' : skuMsg.specialPrint == 1 ? '是' : '' }}</span>
        </el-form-item>
        <el-form-item label="基础P数：" prop="basePage">
          <span @click="asd">{{ skuMsg.basePage }}</span>
        </el-form-item>
        <el-form-item label="一次增加P数：" prop="baseStep">
          <el-input v-model.number="skuMsg.baseStep" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.baseStep }}</span>
        </el-form-item>
        <el-form-item label="最大P数：" prop="maxPage">
          <el-input v-model.number="skuMsg.maxPage" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.maxPage }}</span>
        </el-form-item>
        <div style="display: flex;">
          <el-form-item label="基础P平台价格：" prop="basePagePrice">
            <el-input v-model="skuMsg.basePagePrice" @input="changeBasePagePrice" placeholder="" v-if="isEditSku !== 'check'"></el-input>
            <span v-else>{{ skuMsg.basePagePrice }}</span>
          </el-form-item>
          <el-form-item label="基础P积分价格：" prop="basePagePoints" v-if="$route.query.showPoint == 'true'">
            <el-input v-model="skuMsg.basePagePoints" @input="changeBasePagePoints" placeholder="" v-if="isEditSku !== 'check'"></el-input>
            <span v-else>{{ skuMsg.basePagePoints }}</span>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="增加一次平台价格：" prop="baseStepPrice">
            <el-input v-model="skuMsg.baseStepPrice" @inpput="changeBaseStepPrice" placeholder="" v-if="isEditSku !== 'check'"></el-input>
            <span v-else>{{ skuMsg.baseStepPrice }}</span>
          </el-form-item>
          <el-form-item label="增加一次积分价格：" prop="baseStepPoints" v-if="$route.query.showPoint == 'true'">
            <el-input v-model="skuMsg.baseStepPoints" @input="changeBaseStepPoints" placeholder="" v-if="isEditSku !== 'check'"></el-input>
            <span v-else>{{ skuMsg.baseStepPoints }}</span>
          </el-form-item>
        </div>
        <el-form-item label="基础P在线支付价格:" prop="onlineSalePrice">
          <el-input v-model="skuMsg.onlineSalePrice" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.onlineSalePrice }}</span>
        </el-form-item>
        <el-form-item label="增加一次在线支付价格：" prop="onlineBaseStepPrice">
          <el-input v-model="skuMsg.onlineBaseStepPrice" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.onlineBaseStepPrice }}</span>
        </el-form-item>
        <!-- 新加的 -->
        <el-form-item label="基础P初创平台价格：" prop="startupsBasePagePrice" v-if="startupsSpu == 'true'">
          <el-input v-model="skuMsg.startupsBasePagePrice" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.startupsBasePagePrice }}</span>
        </el-form-item>
        <el-form-item label="增加一次初创平台价格：" prop="startupsBaseStepPrice" v-if="startupsSpu == 'true'">
          <el-input v-model="skuMsg.startupsBaseStepPrice" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.startupsBaseStepPrice }}</span>
        </el-form-item>
        <el-form-item label="基础P推荐终端价格:" prop="terminalSalePrice">
          <el-input v-model="skuMsg.terminalSalePrice" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.terminalSalePrice }}</span>
        </el-form-item>
        <el-form-item label="增加一次推荐终端价格" prop="terminalStepSalePrice">
          <el-input v-model="skuMsg.terminalStepSalePrice" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.terminalStepSalePrice }}</span>
        </el-form-item>
        <!-- <el-form-item label="最低终端价格:" prop="salePrice">
          <el-input v-model="skuMsg.salePrice" placeholder="" v-if="isEditSku!=='check'"></el-input>
          <span v-else>{{skuMsg.salePrice}}</span>
        </el-form-item> -->
        <!-- <el-form-item label="批量数量:" prop="salePrice">
          <el-input v-model="skuMsg.salePrice" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.salePrice }}</span>
        </el-form-item>
        <el-form-item label="批量价格:" prop="salePrice">
          <el-input v-model="skuMsg.salePrice" placeholder="" v-if="isEditSku !== 'check'"></el-input>
          <span v-else>{{ skuMsg.salePrice }}</span>
        </el-form-item> -->
      </el-form>
      <el-tabs v-if="addSkuStep === 2" v-model="activeName">
        <el-tab-pane v-for="(item, index) in pageNameTableData" :key="item.id + item.pageName" :label="$store.state.pms.pageType[item.pageTypeCode] + '设置'" :name="'a' + index">
          <div class="settextbox">
            <p>
              <!-- 最大P数：{{item.pageTypeCode==='SINGLE'?skuMsg.singlePage:item.pageTypeCode==='COVER'?skuMsg.coverPage:+item.pageNum===+skuMsg.basePage?skuMsg.maxPage:+skuMsg.maxPage - +skuMsg.coverPage}}P -->
              <!-- 增加的P数都是内页增加的，其余都固定 --> 最大P数：{{ item.pageTypeCode !== 'TEXT' ? item.pageNum : +item.pageNum + (+skuMsg.maxPage - +skuMsg.basePage) }}P
            </p>
            <p>
              <!-- 最小P数：{{item.pageTypeCode==='SINGLE'?item.pageNum:item.pageTypeCode==='COVER'?skuMsg.coverPage:+item.pageNum===+skuMsg.basePage?skuMsg.basePage:+skuMsg.basePage - +skuMsg.coverPage}}P -->
              最小P数：{{ item.pageNum }}P
            </p>
            <p>1P=2页</p>
          </div>
          <el-form ref="form" :model="item" label-width="200px">
            <el-form-item v-for="(bar, index2) in item.barCodeList" :key="bar.id" :label="bar.barName + '出现位置：'">
              <el-select v-model="skuMsg.skuPageSettingVOList[index].barCodePositionList[index2].barCodePosition" placeholder="" :disabled="isEditSku === 'check'">
                <el-option v-for="pos in item.barPosition" :key="pos.id + pos.dictValue" :label="pos.dictValue" :value="pos.dictCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="不进入合成页序：">
              <el-input style="width:50px" v-model="skuMsg.skuPageSettingVOList[index].noComposePageNumStart" :disabled="isEditSku === 'check'">
              </el-input> 到 <el-input style="width:50px;margin-left:10px" v-model="skuMsg.skuPageSettingVOList[index].noComposePageNumEnd" :disabled="isEditSku === 'check'">
              </el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入不进入合成的页序区间，已确定不<br />进入合成的页序，将会锁定不可编辑，<br>不可调序，使用”,“隔开。</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="合成后要删除的页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].deletePage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入合成后要删除的页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item v-if="item.typeName !== '封面'" label="不可排序页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].noAllowSortPage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入不可排序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="不可编辑页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].noAllowEditPage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入不可编辑页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="封面通用文件页序：" v-if="!skuMsg.specialPrint && ($store.state.pms.pageType[item.pageTypeCode] == '封面')">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].generalFilePage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入封面通用文件页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="pdf页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].pdfPage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入pdf页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="扉页通用烫金PDF页序：" v-if="$store.state.pms.pageType[item.pageTypeCode] == '内页'">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].titlePagePdfPage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入扉页通用烫金PDF页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="只读页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].readonlyPage" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入只读页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="半页不可编辑页序：">
              <i class="el-icon-circle-plus" @click="addPageVOS(index)" style="font-size: 18px;"></i>
              <div v-for="(a, b) in skuMsg.skuPageSettingVOList[index].skuPageSettingHalfPageVOS" :key="b" style="display:flex;margin-top: 10px;">
                <el-select v-model="a.sort" placeholder="请选择" clearable :disabled="isEditSku === 'check'">
                  <el-option label="正序" :value="0"></el-option>
                  <el-option label="倒序" :value="1"></el-option>
                </el-select>
                <el-input v-model="a.noAllowEditPage" :disabled="isEditSku === 'check'" placeholder="请输入页序" style="margin-left: 20px;"></el-input>
                <el-select v-model="a.position" placeholder="请选择" clearable :disabled="isEditSku === 'check'">
                  <el-option label="左" :value="0"></el-option>
                  <el-option label="右" :value="1"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <!-- 以下新加 -->
            <el-form-item label="是否拆分pdf:">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].splitPdf" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                :disabled="isEditSku === 'check'"></el-switch> </el-form-item>
            <!-- <el-form-item label="偶数页:" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].splitEvenPage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="switchChange($event, index, 1)"></el-switch>
            </el-form-item> -->
            <el-form-item label="银卡拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageYk" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageYkDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="透片拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTp" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTpDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="磨砂透片拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMstp" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMstpDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫哑金拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTjuv" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTjuvDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫亮金拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTljuv" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTljuvDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫镭射银拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsyuv" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsyuvDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫镭射金拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsjuv" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsjuvDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="MGI镭射银卡UV拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMGIYuv" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMGIYuvDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="牛皮纸拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageNpz" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageNpzDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="其他拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageQt" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageQtDesc" :disabled="isEditSku === 'check'"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="是否镜像:">
              <el-radio-group v-model="skuMsg.skuPageSettingVOList[index].flip" :disabled="isEditSku === 'check'">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">水平翻转</el-radio>
                <el-radio :label="2">垂直翻转</el-radio>
                <el-radio :label="3">同时翻转</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="全部页:" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].flipAllPage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="switchChange($event, index, 1)" :disabled="isEditSku === 'check'"></el-switch>
            </el-form-item>
            <el-form-item label="偶数页:" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].flipEvenPage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="switchChange($event, index, 2)" :disabled="isEditSku === 'check'"></el-switch>
            </el-form-item>
            <el-form-item label="奇数页:" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].flipOddPage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="switchChange($event, index, 3)" :disabled="isEditSku === 'check'"></el-switch>
            </el-form-item>
            <el-form-item label="指定页：" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].flipSpecifyPage" :disabled="isEditSku === 'check'" @change="switchChange($event, index, 4)"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button v-show="addSkuStep === 1" type="primary" @click="addSkuStep = 2" v-preventReClick>下一步</el-button>
        <el-button v-show="addSkuStep === 2" type="primary" @click="addSkuStep = 1" v-preventReClick>上一步</el-button>
        <el-button v-show="addSkuStep === 2" type="primary" @click="addSkuDialog = false" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import adminPickCollTemplate from '../CheckSKUDetails/adminPickCollTemplate.vue'
import VPagination from '@/components/Pagination/index.vue'
import { skuAssociateTemplateGroup, skuUpdate, skuGroupDetail, dictQueryByPid, skuGroupUpdateCurrency, skuSampleDelete, skuSampleSave, groupSkuRelateGroup, composeGroupDetail, skuGroupUpdate, skuDelete, skuAdd, barCodePosition, groupListPageing, groupQueryGroupById, groupGetGroupList, propertyGetPropertyList, sampleListNoPaging, skuGroupAudit, skuSpecialStoreList } from '@/api/pms'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
import { getPointRules } from '@/api/crm'
export default {
  name: 'sku-details',
  components: {
    VPagination, adminPickCollTemplate
  },
  data () {
    return {
      isdisabled: false,
      startupsSpu: this.$route.query.startupsSpu, // 用来判断是不是初创产品
      dictList: [],
      awsSdk: null,
      addCorrelationType: '',
      selectTemplateList: [],
      addCorrelationSkuId: '',
      addCorrelation: false,
      deleteSkuMsg: null,
      deleteSkuDialog: false,
      isEditSku: false,
      barPosition: {
        cover: {
          has: [],
          none: []
        },
        page: {
          has: [],
          none: []
        }
      },
      activeName: 'a0',
      sizeGroupList: [],
      sizeGroupQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      templateList: [],
      checkTemplateDialog: false,
      templateGroupList: [],
      allPropertyList: [],
      propertyList: [],
      value: [],
      searchGroupVo: {
        auditStatus: '',
        composeSizeGroupId: '',
        createTimeBegin: '',
        createTimeEnd: '',
        groupBelong: '',
        groupName: '',
        isAssociatedeSizeGroup: '',
        page: 1,
        propertyId: '',
        skuId: '',
        templateThemeId: ''
      },
      templateDialog: false,
      sizeGroupTypeList: [],
      searchComposeSizeGroupVO: {
        groupCategoryId: '',
        groupName: '',
        userId: localStorage.getItem('userId') ? localStorage.getItem('userId') : ''
      },
      sizeDialog: false,
      addSkuStep: 1,
      status: this.$route.query.auditStatus,
      editPriceDialog: false,
      basicInfo: {
        skuList: []
      },
      specialPriceData: [{
        platformNum: '',
        platformName: '',
        salesman: '',
        operation: {
          check: '查看',
          delete: '删除'
        }
      }],
      priceTableList: [],
      isShow: false,
      editPrice: '',
      editInfo: {
        samplePrice: '',
        sampleThemeIdSet: [],
        skuGroupImage: '',
        skuGroupName: ''
      },
      specialStoreList: [],
      checkDialog: false,
      haddleSizeGroupDialog: false,
      checkSizeGroupTableData: [{
        groupName: '',
        sizeList: []
      }],
      addSkuDialog: false,
      skuMsg: {
        basePage: 0,
        basePagePrice: 0,
        basePagePoints: 0,
        baseStep: 1,
        baseStepPrice: 0,
        baseStepPoints: 0,
        onlineBaseStepPrice: 0,
        composeSizeGroupId: 0,
        maxPage: 0,
        skuName: '',
        skuFrontName: '',
        coverPage: '',
        skuPageSettingVOList: [
          {
            noAllowEditPage: '',
            deletePage: '',
            noAllowSortPage: '',
            generalFilePage: '',
            titlePagePdfPage: '',
            pdfPage: '',
            readonlyPage: '',
            skuPageSettingHalfPageVOS: [
              {
                sort: null,
                noAllowEditPage: '',
                position: null
              }
            ],
            noComposePageNumEnd: 0,
            noComposePageNumStart: 0,
            skuPageType: '',
            splitPdf: 0,
            splitPageYk: '',
            splitPageYkDesc: '',
            splitPageTp: '',
            splitPageTpDesc: '',
            splitPageMstp: '',
            splitPageMstpDesc: '',
            splitPageTjuv: '',
            splitPageTjuvDesc: '',
            splitPageTljuv: '',
            splitPageTljuvDesc: '',
            splitPageTlsyuv: '',
            splitPageTlsyuvDesc: '',
            splitPageTlsjuv: '',
            splitPageTlsjuvDesc: '',
            splitPageMGIYuv: '',
            splitPageMGIYuvDesc: '',
            splitPageNpz: '',
            splitPageNpzDesc: '',
            splitPageQt: '',
            splitPageQtDesc: '',
            flip: 0,
            flipAllPage: 0,
            flipEvenPage: 0,
            flipOddPage: 0,
            flipSpecifyPage: ''
          }
        ]
      },
      isDiy: null,
      isComposeHalfP: '',
      isZeroPurchase: '',
      limitQuantity: '',
      specialPrint: '',
      coverPosition: '',
      leftParam: '',
      topParam: '',
      skuMsgName: '',
      pageNameTableData: [],
      sampleList: [],
      selectSample: '',
      tempQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      defaultSizeGroup: null,
      basePagePointsEdited: false,
      baseStepPointsEdited: false,
      pointExchangeRote: 0
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getSkuGroupMsg()
    this.getFormatList()
    this.getBarPositionList()
    if (this.$route.query.showPoint == 'true') {
      this.getUserPointExchangeRote()
    }
  },
  methods: {
    getUserPointExchangeRote () {
      getPointRules('WD').then(res => {
        if (res.data.success) {
          this.pointExchangeRote = res.data.data.exchangeRate
        }
      })
    },
    changeBasePagePrice () {
      console.log('changeBasePagePrice')
      if (this.basePagePointsEdited) {
        this.$forceUpdate()
        return
      }
      if (!this.pointExchangeRote) {
        this.$forceUpdate()
        return
      }
      this.skuMsg.basePagePoints = Math.round(this.skuMsg.basePagePrice * this.pointExchangeRote)
      this.$forceUpdate()
    },
    changeBasePagePoints () {
      this.basePagePointsEdited = true
      this.$forceUpdate()
    },
    changeBaseStepPrice () {
      console.log('changeBasePagePrice')
      if (this.baseStepPointsEdited) {
        this.$forceUpdate()
        return
      }
      if (!this.pointExchangeRote) {
        this.$forceUpdate()
        return
      }
      this.skuMsg.baseStepPoints = Math.round(this.skuMsg.baseStepPrice * this.pointExchangeRote)
      this.$forceUpdate()
    },
    changeBaseStepPoints () {
      this.baseStepPointsEdited = true
      this.$forceUpdate()
    },
    addPageVOS (index) {
      this.skuMsg.skuPageSettingVOList[index].skuPageSettingHalfPageVOS.push(
        {
          sort: null,
          noAllowEditPage: '',
          position: null
        })
    },
    switchChange (value, index, type) {
      if (type == 1 && value == 1) {
        this.skuMsg.skuPageSettingVOList[index].flipEvenPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipOddPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipSpecifyPage = ''
      } else if (type == 2 && value == 1) {
        this.skuMsg.skuPageSettingVOList[index].flipAllPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipOddPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipSpecifyPage = ''
      } else if (type == 3 && value == 1) {
        this.skuMsg.skuPageSettingVOList[index].flipAllPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipEvenPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipSpecifyPage = ''
      } else if (type == 4 && value) {
        this.skuMsg.skuPageSettingVOList[index].flipAllPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipEvenPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipOddPage = 0
      }
    },
    // 编辑sku
    editSku (row) {
      composeGroupDetail(row.composeSizeGroupId).then(res => {
        if (res.data.success) {
          let list = []
          list = res.data.data.sizeList
          this.skuMsgName = res.data.data.groupName
          this.skuMsg = JSON.parse(JSON.stringify(row))
          let pages = {}
          let cover = 0
          let single = 0
          list.forEach(page => {
            // pages[page.pageTypeCode] = page.spuPageName.isBase ? row.coverPage : 0
            if (page.pageTypeCode === 'COVER') {
              pages[page.pageTypeCode] = page.spuPageName.isBase ? row.coverPage : 0
              if (!page.spuPageName.isBase) {
                pages[page.pageTypeCode] = false
              }
            } else if (page.pageTypeCode === 'SINGLE') {
              pages[page.pageTypeCode] = page.spuPageName.isBase ? row.singlePage : 0
              if (!page.spuPageName.isBase) {
                pages[page.pageTypeCode] = false
              }
            }
          })
          list.forEach(page => {
            // // 页面名称表
            // if (page.typeName === '封面' && page.spuPageName.pageTypeId === 1) {
            page.isBase = page.spuPageName.isBase
            page.isEditable = page.spuPageName.isEditable
            if (page.pageTypeCode === 'TEXT') {
              let num = row.basePage
              for (let key in pages) {
                if (pages[key]) {
                  num -= pages[key]
                }
              }
              page.pageNum = num
            } else if (page.pageTypeCode === 'COVER') { // 新加的封面可回显多页
              page.pageNum = row.coverPage
            } else {
              page.pageNum = !pages[page.pageTypeCode] ? 1 : pages[page.pageTypeCode]
            }
            // page.pageNum = page.pageTypeCode === 'TEXT' ? row.basePage - cover - single : pages[page.pageTypeCode]
            // page.pageNum = page.pageTypeCode === 'COVER' ? cover : page.pageTypeCode === 'SINGLE' ? single : page.pageTypeCode === 'TEXT' ? row.basePage - cover - single : -1
            // } else {
            //     page.isBase = page.spuPageName.isBase
            //     page.isEditable = page.spuPageName.isEditable
            //     page.pageNum = 1
            // }
          })
          // console.log('this.skuMsg.skuPageSettingList[index].skuPageCodeSettingList.', this.skuMsg.skuPageSettingList)
          this.skuMsg.skuPageSettingVOList = []
          list.forEach((item, index) => {
            let obj = {
              barCodePositionList: [],
              noAllowEditPage: this.skuMsg.skuPageSettingList[index].noAllowEditPage,
              deletePage: this.skuMsg.skuPageSettingList[index].deletePage,
              noAllowSortPage: this.skuMsg.skuPageSettingList[index].noAllowSortPage,
              generalFilePage: this.skuMsg.skuPageSettingList[index].generalFilePage,
              titlePagePdfPage: this.skuMsg.skuPageSettingList[index].titlePagePdfPage,
              pdfPage: this.skuMsg.skuPageSettingList[index].pdfPage,
              readonlyPage: this.skuMsg.skuPageSettingList[index].readonlyPage,
              skuPageSettingHalfPageVOS: this.skuMsg.skuPageSettingList[index].skuPageSettingHalfPageList?.length > 0 ? this.skuMsg.skuPageSettingList[index].skuPageSettingHalfPageList : [
                {
                  sort: null,
                  noAllowEditPage: '',
                  position: null
                }
              ],
              noComposePageNumEnd: this.skuMsg.skuPageSettingList[index].noComposePageNumEnd,
              noComposePageNumStart: this.skuMsg.skuPageSettingList[index].noComposePageNumStart,
              skuPageType: this.skuMsg.skuPageSettingList[index].skuPageType,
              splitPdf: this.skuMsg.skuPageSettingList[index].splitPdf,
              splitPageYk: this.skuMsg.skuPageSettingList[index].splitPageYk,
              splitPageYkDesc: this.skuMsg.skuPageSettingList[index].splitPageYkDesc,
              splitPageTp: this.skuMsg.skuPageSettingList[index].splitPageTp,
              splitPageTpDesc: this.skuMsg.skuPageSettingList[index].splitPageTpDesc,
              splitPageMstp: this.skuMsg.skuPageSettingList[index].splitPageMstp,
              splitPageMstpDesc: this.skuMsg.skuPageSettingList[index].splitPageMstpDesc,
              splitPageTjuv: this.skuMsg.skuPageSettingList[index].splitPageTjuv,
              splitPageTjuvDesc: this.skuMsg.skuPageSettingList[index].splitPageTjuvDesc,
              splitPageTljuv: this.skuMsg.skuPageSettingList[index].splitPageTljuv,
              splitPageTljuvDesc: this.skuMsg.skuPageSettingList[index].splitPageTljuvDesc,
              splitPageTlsyuv: this.skuMsg.skuPageSettingList[index].splitPageTlsyuv,
              splitPageTlsyuvDesc: this.skuMsg.skuPageSettingList[index].splitPageTlsyuvDesc,
              splitPageTlsjuv: this.skuMsg.skuPageSettingList[index].splitPageTlsjuv,
              splitPageTlsjuvDesc: this.skuMsg.skuPageSettingList[index].splitPageTlsjuvDesc,
              splitPageMGIYuv: this.skuMsg.skuPageSettingList[index].splitPageMGIYuv,
              splitPageMGIYuvDesc: this.skuMsg.skuPageSettingList[index].splitPageMGIYuvDesc,
              splitPageNpz: this.skuMsg.skuPageSettingList[index].splitPageNpz,
              splitPageNpzDesc: this.skuMsg.skuPageSettingList[index].splitPageNpzDesc,
              splitPageQt: this.skuMsg.skuPageSettingList[index].splitPageQt,
              splitPageQtDesc: this.skuMsg.skuPageSettingList[index].splitPageQtDesc,
              flip: this.skuMsg.skuPageSettingList[index].flip ? Number(this.skuMsg.skuPageSettingList[index].flip) : 0,
              flipAllPage: this.skuMsg.skuPageSettingList[index].flipAllPage,
              flipEvenPage: this.skuMsg.skuPageSettingList[index].flipEvenPage,
              flipOddPage: this.skuMsg.skuPageSettingList[index].flipOddPage,
              flipSpecifyPage: this.skuMsg.skuPageSettingList[index].flipSpecifyPage
            }
            console.log('item.barCodeList', item.barCodeList)
            item.barCodeList.forEach(bar => {
              console.log('bar', bar)
              if (this.skuMsg.skuPageSettingList[index].skuPageCodeSettingList.length > 0) {
                this.skuMsg.skuPageSettingList[index].skuPageCodeSettingList.forEach(set => {
                  // console.log(set.spuBarCode, bar)
                  //  新增的判断if (set.spuBarCode && bar) {
                  if (set.spuBarCode) {
                    if (set.spuBarCode.id === bar.id) {
                      obj.barCodePositionList.push({
                        barCodeId: bar.id,
                        barCodePosition: set.barCodePosition
                      })
                      // this.barPosition.page.has.forEach(pos => {
                      //   if (+pos.id === +set.barCodePosition) {
                      //   }
                      // })
                    }
                  } else {
                    obj.barCodePositionList.push({
                      barCodeId: bar.id,
                      barCodePosition: set.barCodePosition
                    })
                  }
                })
              } else {
                obj.barCodePositionList.push({
                  barCodeId: bar.id,
                  barCodePosition: ''
                })
              }
            })
            console.log('skuMsg', this.skuMsg)
            this.skuMsg.skuPageSettingVOList.push(obj)
            if (item.spuPageName.pageTypeCode === 'COVER') {
              if (this.basicInfo.whitePageId) {
                item.barPosition = this.barPosition.cover.has
              } else {
                item.barPosition = this.barPosition.cover.none
              }
            } else {
              if (this.basicInfo.whitePageId) {
                item.barPosition = this.barPosition.page.has
              } else {
                item.barPosition = this.barPosition.page.none
              }
            }
          })
          this.pageNameTableData = JSON.parse(JSON.stringify(list))
          this.skuMsg = JSON.parse(JSON.stringify(this.skuMsg))
          this.countP()
          this.sizeDialog = false
          this.addSkuDialog = true
          this.$forceUpdate()
        }
      })
    },
    // 获取条码位置
    getBarPositionList () {
      barCodePosition().then(res => {
        if (res.data.success) {
          this.barPosition.page.has = res.data.data
          this.barPosition.page.none = res.data.data.filter(item => {
            return item.dictValue.indexOf('白页') === -1
          })
          this.barPosition.cover.has = res.data.data.filter(item => {
            return item.dictValue.indexOf('步长') === -1
          })
          this.barPosition.cover.none = this.barPosition.cover.has.filter(item => {
            return item.dictValue.indexOf('白页') === -1
          })
        }
      })
    },
    // 审核
    check (type) {
      if (type === '审核通过' && this.basicInfo.skuList.length === 0) {
        this.$message.error('没有sku,未通过审核')
        return
      }
      let status = ''
      status = type === '审核通过' ? 'AUDIT_SUCCESS' : type === '审核拒绝' ? 'AUDIT_FAIL' : ''
      skuGroupAudit({ skuGroupId: this.$route.query.id, status }).then(res => {
        if (res.data.success) {
          if (type === '审核通过') {
            this.$message.success('已通过')
          } else if (type === '审核拒绝') {
            this.$message.error('已拒绝')
          }
          this.$router.go(-1)
        }
      })
    },
    asd () {
    },
    closed () {
      this.addSkuStep = 1
      this.activeName = 'a0'
    },
    // 取消关联
    cancelCorrelation () {
      let groupSkuXrefVo = {
        groupIds: [],
        skuId: this.addCorrelationSkuId,
        state: 0
      }
      this.selectTemplateList.forEach(item => {
        groupSkuXrefVo.groupIds.push(item.id)
      })
      groupSkuRelateGroup([groupSkuXrefVo]).then(res => {
        if (res.data.success) {
          this.$message.success('取消关联成功')
          this.searchGroupVo.skuId = this.addCorrelationSkuId
          this.sizeGroupQueryInfo.pageNum = 1
          this.getTemplateThemeList()
        }
      })
    },
    // 关联模板
    Correlation () {
      if (this.addCorrelationType === 'single') {
        let groupSkuXrefVo = {
          groupIds: [],
          skuId: this.addCorrelationSkuId,
          state: 1
        }
        this.selectTemplateList.forEach(item => {
          groupSkuXrefVo.groupIds.push(item.id)
        })
        groupSkuRelateGroup([groupSkuXrefVo]).then(res => {
          if (res.data.success) {
            this.$message.success('关联成功')
            this.searchGroupVo.skuId = this.addCorrelationSkuId
            this.sizeGroupQueryInfo.pageNum = 1
            this.getTemplateThemeList()
            this.addCorrelation = false
          }
        })
      } else if (this.addCorrelationType === 'all') {
        let templateVOList = []
        let groupIds = []
        this.selectTemplateList.forEach(temp => {
          groupIds.push(temp.id)
        })
        this.basicInfo.skuList.forEach(sku => {
          templateVOList.push({
            groupIds,
            skuId: sku.id,
            state: 1
          })
        })
        groupSkuRelateGroup(templateVOList).then(res => {
          if (res.data.success) {
            this.$message.success('关联成功')
            this.addCorrelation = false
            this.templateDialog = false
          }
        })
      }
    },
    // 删除Sku
    deleteSku () {
      skuDelete(this.deleteSkuMsg.row.id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.basicInfo.skuList.splice(this.deleteSkuMsg.$index, 1)
          this.deleteSkuDialog = false
        }
      })
    },
    // 计算基础p
    countP (val) {
      let num = 0
      this.pageNameTableData.forEach(item => {
        num += item.isBase ? +item.pageNum : 0
        this.skuMsg[this.$store.state.pms.pageType[item.pageTypeCode] + 'Page'] = item.pageNum
        // if (item.pageTypeCode === 'COVER') {
        //   this.skuMsg.coverPage = item.pageNum
        // } else if (item.pageTypeCode === 'SINGLE') {
        //   this.skuMsg.singlePage = item.pageNum
        // }
      })
      this.skuMsg.basePage = num
      this.$forceUpdate()
    },
    // 获取尺寸组信息
    getSizeGroupList () {
      groupListPageing({ pageNum: this.sizeGroupQueryInfo.pageNum, pageSize: this.sizeGroupQueryInfo.pageSize, data: this.searchComposeSizeGroupVO }).then(res => {
        this.sizeGroupQueryInfo.total = res.data.data.total
        if (res.data.success) {
          let list = res.data.data.records
          let num = 0
          // this.tableData = res.data.data.records
          res.data.data.records.forEach(item => {
            composeGroupDetail(item.id).then(res2 => {
              item.detail = res2.data.data
              num++
              if (num >= list.length) {
                this.sizeGroupList = list
              }
            })
          })
        }
      })
    },
    // 获取模板详情
    getTemplateGroupMsg (id) {
      groupQueryGroupById(id).then(res => {
        if (res.data.success) {
          // this.tem
          let arr = []
          res.data.data.templateList.forEach(page => {
            // page.templates.forEach(item => {
            //   arr.push(item)
            // })
            page.groupVos.forEach(item => {
              item.templates.forEach(temp => {
                arr.push({ ...temp, pageTypeCode: item.pageTypeCode })
              })
            })
          })
          this.templateList = arr
        }
      })
    },
    // 获取模板列表
    getTemplateThemeList () {
      groupGetGroupList({ pageSize: this.tempQueryInfo.pageSize, pageNum: this.tempQueryInfo.pageNum, searchGroupVo: this.searchGroupVo }).then(res => {
        if (res.data.success) {
          this.templateGroupList = res.data.data.records
          this.tempQueryInfo.total = res.data.data.total
        }
      })
    },
    // 管理模板
    tempAdmin (scope) {
      // 获取该sku的尺寸组详情
      composeGroupDetail(scope.row.composeSizeGroupId).then(res => {
        if (res.data.success) {
          let list = []
          res.data.data.sizeList.forEach(size => {
            list.push(...size.spuPageName.templateProperty.split(','))
          })
          list = Array.from(new Set(list))
          this.propertyList = this.allPropertyList.filter(item => {
            return list.indexOf(item.propertyName) !== -1
          })
          this.addCorrelation = false
          this.addCorrelationType = 'single'
          this.addCorrelationSkuId = scope.row.id
          this.sizeGroupQueryInfo.pageNum = 1
          this.searchGroupVo.skuId = scope.row.id
          this.searchGroupVo.composeSizeGroupId = scope.row.composeSizeGroupId
          this.getTemplateThemeList()
          this.templateDialog = true
        }
      })
    },
    // 获取模板性质列表
    getFormatList () {
      propertyGetPropertyList().then(res => {
        if (res.data.success) {
          this.allPropertyList = res.data.data
        }
      })
    },
    // 查看尺寸组
    checkSizeGroup (row) {
      composeGroupDetail(row.composeSizeGroupId).then(res => {
        if (res.data.success) {
          this.checkSizeGroupTableData = [res.data.data]
        }
      })
      this.haddleSizeGroupDialog = true
    },
    // 获取sku组信息
    getSkuGroupMsg () {
      skuGroupDetail(this.$route.query.id).then(res => {
        if (res.data.success) {
          let list = res.data.data
          this.isDiy = list.isDiy
          // this.startupsSpu = list.startupsSpu
          list.skuList = list.skuList.filter(sku => {
            return !sku.isSample
          })
          // 判断有没有sku，有=>尺寸组确定
          if (list.skuList.length !== 0) {
            if (this.$route.query.spuProperty !== 'NORMAL') {
              composeGroupDetail(list.skuList[0].composeSizeGroupId).then(res2 => {
                let obj = res2.data.data
                obj.detail = res2.data.data
                this.defaultSizeGroup = obj
              })
            }
          }
          // 处理属性
          list.dictList = []
          let dict = list.dictSet.split(';')
          dict.pop()
          dict.forEach(item => {
            item = item.split(':')
            list.dictList.push(item)
          })
          // list.dictSet
          this.basicInfo = list
        }
      })
      if (this.$hasPermission('pms:admin:special:store:list')) {
        // 获取特殊价格加盟店列表
        skuSpecialStoreList(this.$route.query.id).then(res => {
          if (res.data.success) {
            this.specialStoreList = res.data.data.data
          }
        })
      }
    },
    // ------------------------------------------------------
    count () {
      this.basicInfo.skuList.forEach((item, index) => {
        this.priceTableList[index] = []
        for (let i = item.basePage; i <= item.maxPage; i += item.baseStep) {
          this.priceTableList[index].push({
            page: i,
            price: ((i - item.basePage) / item.baseStep * item.baseStepPrice + item.basePagePrice).toFixed(2),
            onlinePrice: ((i - item.basePage) / item.baseStep * item.onlineBaseStepPrice + item.onlineSalePrice).toFixed(2),
            salePrice: ((i - item.basePage) / item.baseStep * item.terminalStepSalePrice + item.terminalSalePrice).toFixed(2),
            startupsPrice: ((i - item.basePage) / item.baseStep * item.startupsBaseStepPrice + item.startupsBasePagePrice).toFixed(2)
          })
        }
      })
      this.isShow = true
    },
    changePage (val) {
      this.tempQueryInfo = val
      this.getTemplateThemeList()
    },
    sizeGroupchangePage (val) {
      this.sizeGroupQueryInfo = val
      this.getSizeGroupList()
    },
    handleSelectionChange (val) {
      this.selectTemplateList = val
    }
  }
}
</script>
<style scoped lang="less">
@import "styles";
@deep: ~">>>";
</style>
